import React from 'react';
import AboutPage from '@/components/Pages/AboutPage';

export default function About() {
  return <AboutPage />;
}
